import { render, staticRenderFns } from "./JeecgOrderCustomerList.vue?vue&type=template&id=3a4a3d93&scoped=true&"
import script from "./JeecgOrderCustomerList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderCustomerList.vue?vue&type=style&index=0&id=3a4a3d93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a3d93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4a3d93')) {
      api.createRecord('3a4a3d93', component.options)
    } else {
      api.reload('3a4a3d93', component.options)
    }
    module.hot.accept("./JeecgOrderCustomerList.vue?vue&type=template&id=3a4a3d93&scoped=true&", function () {
      api.rerender('3a4a3d93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/tablist/JeecgOrderCustomerList.vue"
export default component.exports